import { render, staticRenderFns } from "./MyTickerSetting_nw_PC.vue?vue&type=template&id=5842e6b6&scoped=true"
import script from "./MyTickerSetting_nw_PC.vue?vue&type=script&lang=js"
export * from "./MyTickerSetting_nw_PC.vue?vue&type=script&lang=js"
import style0 from "./MyTickerSetting_nw_PC.vue?vue&type=style&index=0&id=5842e6b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5842e6b6",
  null
  
)

export default component.exports